/* eslint-disable */
import { useEffect, useState } from "react";
import Select from "react-select";
import { useTranslation } from "react-i18next";

import { getData, postData, putData, deleteData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import { filterOperators } from "data/Filter/filterOperators";
import { filterAdvanceSelectStyle } from "Config/Config";

const executionTypeOptions = [
  { label: "Reactive",  value: "reactive" },
  { label: "Proactive", value: "proactive" },
];

const visibilityOptions = [
  { label: "Public",  value: true  },
  { label: "Private", value: false },
];

const statusOptions = [
  { label: "Active",  value: "active"  },
  { label: "Deleted", value: "deleted" },
];

// ─────────────────────────────────────────────────────────────────────────────
const AutomationTemplateFilterPopup = ({
  setJsonFilterQuery,
  reloadList = () => {},
  isFilterReset = false,
  setIsFilterReset = () => {},
}) => {
  const { t } = useTranslation();
  const token = localStorage.getItem("token");
  const MODULE_SLUG = "MOD_AUTOMATION_TEMPLATE";

  const filterFields = [
    { name: "name",          label: t("Template Name"),  type: "string" },
    { name: "executiontype", label: t("Execution Type"), type: "multi-select", callback: () => Promise.resolve(executionTypeOptions) },
    { name: "ispublic",      label: t("Visibility"),     type: "multi-select", callback: () => Promise.resolve(visibilityOptions) },
    { name: "status",        label: t("Status"),         type: "multi-select", callback: () => Promise.resolve(statusOptions) },
    { name: "createdAt",     label: t("Created Date"),   type: "date" },
  ];

  filterFields.forEach((f) => { f.operators = filterOperators[f.type] || []; });

  const [selectedFieldValue, setSelectedFieldValue] = useState(null);
  const [selectedField, setSelectedField]           = useState("");
  const [selectedOperator, setSelectedOperator]     = useState("");
  const [inputValue, setInputValue]                 = useState("");
  const [inputValue2, setInputValue2]               = useState("");
  const [filters, setFilters]                       = useState([]);
  const [editIndex, setEditIndex]                   = useState(null);
  const [dynamicOptions, setDynamicOptions]         = useState([]);
  const [inputQuery, setInputQuery]                 = useState("");
  const [debouncedQuery, setDebouncedQuery]         = useState("");

  const [savedFilters, setSavedFilters]                     = useState([]);
  const [selectedFilterTemplate, setSelectedFilterTemplate] = useState(null);
  const [filterTemplateName, setFilterTemplateName]         = useState("");
  const [isDefaultTemplate, setIsDefaultTemplate]           = useState(false);
  const [showSaveFilterSection, setShowSaveFilterSection]   = useState(false);
  const [isLoadingSavedFilters, setIsLoadingSavedFilters]   = useState(false);
  const [notification, setNotification]                     = useState("");

  const fieldMeta = filterFields.find((f) => f.name === selectedField);

  const fetchSavedFilters = async () => {
    try {
      const resp = await getData(
        `${url.API_BASE_URL}${url.API_GET_ALL_FILTER}?token=${token}&modulename=${MODULE_SLUG}`
      );
      if (resp.status && Array.isArray(resp.data)) {
        return resp.data.map((item, idx) => ({
          value: item.value || item.name || idx,
          label: item.label || item.name || `Filter ${idx + 1}`,
          conditions: (() => {
            try { return typeof item.conditions === "string" ? JSON.parse(item.conditions) : item.conditions || []; }
            catch { return []; }
          })(),
          isDefault: item.isdefault || false,
          name: item.name,
        }));
      }
      return [];
    } catch (err) { console.error(err.message); return []; }
  };

  const loadSavedFilters = async () => {
    setIsLoadingSavedFilters(true);
    const data = await fetchSavedFilters();
    setSavedFilters(data);
    setIsLoadingSavedFilters(false);
  };

  const handleSelectFilterTemplate = (tpl) => {
    setSelectedFilterTemplate(tpl);
    setFilters(tpl ? (tpl.conditions || []) : []);
  };

  const handleSaveFilterTemplate = async () => {
    try {
      const payload = { name: filterTemplateName, conditions: JSON.stringify(filters), moduleslug: MODULE_SLUG, isdefault: isDefaultTemplate };
      const reqUrl = selectedFilterTemplate
        ? `${url.API_BASE_URL}${url.API_UPDATE_FILTER}/${selectedFilterTemplate.value}?token=${token}`
        : `${url.API_BASE_URL}${url.API_ADD_NEW_FILTER}?token=${token}`;
      const resp = selectedFilterTemplate ? await putData(reqUrl, payload) : await postData(reqUrl, payload);
      if (resp.status) {
        setNotification(t("Filter template saved successfully!"));
        loadSavedFilters();
        setTimeout(() => setNotification(""), 2500);
      }
    } catch (err) { console.error(err.message); }
  };

  const deleteSelectedFilter = async () => {
    if (!selectedFilterTemplate) { alert(t("No template selected.")); return; }
    if (!window.confirm(t("Are you sure you want to delete this template?"))) return;
    try {
      await deleteData(`${url.API_BASE_URL}${url.API_DELETE_FILTER}/${selectedFilterTemplate.value}?token=${token}`);
      setSavedFilters((prev) => prev.filter((f) => f.value !== selectedFilterTemplate.value));
      setSelectedFilterTemplate(null);
      setFilterTemplateName("");
      setIsDefaultTemplate(false);
    } catch (err) { console.error(err.message); }
  };

  const handleFieldChange = async (fieldOption) => {
    setSelectedFieldValue(fieldOption);
    setSelectedField(fieldOption.value);
    setSelectedOperator("");
    setInputValue("");
    setInputValue2("");
    setDynamicOptions([]);
    setInputQuery("");
    const meta = filterFields.find((f) => f.name === fieldOption.value);
    if (meta?.type === "multi-select" && meta?.callback) {
      const opts = await meta.callback("");
      setDynamicOptions(opts);
    }
  };

  const handleAddFilter = () => {
    if (!selectedField || !selectedOperator) return;
    const meta = filterFields.find((f) => f.name === selectedField);
    let value = inputValue;
    if (selectedOperator === "between" && meta?.type === "date") {
      if (!inputValue || !inputValue2) return;
      value = [inputValue, inputValue2];
    } else if (meta?.type !== "multi-select" && !inputValue) {
      return;
    }
    const newFilter = { field: selectedField, operator: selectedOperator, value };
    if (editIndex !== null) {
      const updated = [...filters];
      updated[editIndex] = newFilter;
      setFilters(updated);
      setEditIndex(null);
    } else {
      setFilters([...filters, newFilter]);
    }
    setSelectedFieldValue(null);
    setSelectedField("");
    setSelectedOperator("");
    setInputValue("");
    setInputValue2("");
  };

  const handleRemoveFilter = (idx) => setFilters(filters.filter((_, i) => i !== idx));

  const handleEditFilter = (idx) => {
    const f = filters[idx];
    const meta = filterFields.find((fm) => fm.name === f.field);
    setSelectedFieldValue({ label: meta.label, value: meta.name });
    setSelectedField(f.field);
    setSelectedOperator(f.operator);
    if (Array.isArray(f.value)) { setInputValue(f.value); setInputValue2(f.value[1] ?? ""); }
    else { setInputValue(f.value); setInputValue2(""); }
    setEditIndex(idx);
  };

  const resetHandler = () => {
    setSelectedFieldValue(null); setSelectedField(""); setSelectedOperator("");
    setInputValue(""); setInputValue2(""); setFilters([]); setEditIndex(null);
    setSelectedFilterTemplate(null); setFilterTemplateName(""); setIsDefaultTemplate(false);
    setInputQuery(""); setDebouncedQuery(""); setDynamicOptions([]);
  };

  const searchHandler = () => {
    try { setJsonFilterQuery([...filters]); }
    catch (err) { console.error(err.message); }
  };

  const hasConditions = () => filters.length > 0;

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedQuery(inputQuery), 100);
    return () => clearTimeout(timer);
  }, [inputQuery]);

  useEffect(() => {
    if (!selectedField || !fieldMeta?.callback) { setDynamicOptions([]); return; }
    fieldMeta.callback(debouncedQuery).then(setDynamicOptions);
  }, [debouncedQuery, selectedField]);

  useEffect(() => { loadSavedFilters(); }, []);

  useEffect(() => {
    if (isFilterReset) { resetHandler(); setIsFilterReset(false); }
  }, [isFilterReset]);

  return (
    <div
      className="offcanvas offcanvas-end custom-offcanvas"
      tabIndex="-1"
      id="automationTemplateFilter"
      aria-labelledby="automationTemplateFilterLabel"
    >
      <div className="offcanvas-header bg-primary text-white">
        <h5 className="offcanvas-title" id="automationTemplateFilterLabel">
          <span className="material-symbols-outlined align-middle me-2" style={{ fontSize: "20px" }}>filter_list</span>
          {t("Filter Templates")}
        </h5>
        <button type="button" className="btn-close p-0 bg-gray-200 rounded-circle shadow-none m-0"
          data-bs-dismiss="offcanvas" aria-label="Close" onClick={resetHandler} />
      </div>

      <div className="offcanvas-body">
        <form onSubmit={(e) => e.preventDefault()}>

          {/* Saved Filters */}
          <div className="mb-4 border-bottom pb-3">
            <h6 className="fw-bold mb-3">{t("Select Saved Filter")}</h6>
            <Select isClearable options={savedFilters} value={selectedFilterTemplate}
              onChange={(tpl) => { handleSelectFilterTemplate(tpl); setFilterTemplateName(tpl?.label || ""); setIsDefaultTemplate(tpl?.isDefault || false); }}
              placeholder={t("Select a saved filter template")} styles={filterAdvanceSelectStyle()} />
            {isLoadingSavedFilters && <span className="spinner-border spinner-border-sm text-primary ms-2" role="status" />}
          </div>

          {/* Create Filter */}
          <div className="mb-4 border-bottom pb-3">
            <h6 className="fw-bold mb-3 text-primary">{t("Create Filter")}</h6>

            <div className="mb-3">
              <label className="fw-semibold">{t("Select Field")}</label>
              <Select styles={filterAdvanceSelectStyle()} placeholder={t("Select Field")}
                options={filterFields.map((f) => ({ ...f, value: f.name }))}
                value={selectedFieldValue} onChange={handleFieldChange} />
            </div>

            {fieldMeta && (
              <div className="mb-3">
                <label className="fw-semibold">{t("Operator")}</label>
                <select className="form-select border border-secondary rounded px-2" value={selectedOperator}
                  onChange={(e) => setSelectedOperator(e.target.value)}>
                  <option value="">{t("Select Operator")}</option>
                  {fieldMeta.operators.map((op) => <option key={op} value={op}>{op}</option>)}
                </select>
              </div>
            )}

            {selectedOperator && fieldMeta?.type === "string" && (
              <div className="mb-3">
                <label className="fw-semibold">{t("Value")}</label>
                <input type="text" className="form-control border border-secondary rounded px-2"
                  value={inputValue} onChange={(e) => setInputValue(e.target.value)} />
              </div>
            )}

            {selectedOperator && fieldMeta?.type === "date" && (
              <>
                <div className="mb-3">
                  <label className="fw-semibold">{selectedOperator === "between" ? t("From") : t("Date")}</label>
                  <input type="date" className="form-control border border-secondary rounded px-2"
                    value={inputValue} onChange={(e) => setInputValue(e.target.value)} />
                </div>
                {selectedOperator === "between" && (
                  <div className="mb-3">
                    <label className="fw-semibold">{t("To")}</label>
                    <input type="date" className="form-control border border-secondary rounded px-2"
                      value={inputValue2} onChange={(e) => setInputValue2(e.target.value)} />
                  </div>
                )}
              </>
            )}

            {selectedOperator && fieldMeta?.type === "multi-select" && (
              <div className="mb-3">
                <label className="fw-semibold">{t("Choose Options")}</label>
                <Select isMulti options={dynamicOptions} value={inputValue}
                  onChange={(opts) => setInputValue(opts || [])}
                  styles={filterAdvanceSelectStyle()} placeholder={t("Select...")} />
              </div>
            )}

            <div className="d-flex gap-2">
              <button type="button" className="btn btn-outline-primary" onClick={handleAddFilter}>
                {editIndex !== null ? t("Update in Filter") : t("Add in Filter")}
              </button>
              <button type="button" className="btn btn-outline-secondary"
                onClick={() => { setSelectedFieldValue(null); setSelectedField(""); setSelectedOperator(""); setInputValue(""); setInputValue2(""); setEditIndex(null); }}>
                {t("Clear")}
              </button>
            </div>
          </div>

          {/* Active Filters */}
          {hasConditions() && (
            <div className="mt-4 border-bottom pb-3"
              style={{ background: "#f8fafc", borderRadius: "12px", boxShadow: "0 2px 8px rgba(0,0,0,0.04)", padding: "20px 16px", marginBottom: "24px", border: "1px solid #e3e8ef" }}>
              <h6 className="fw-bold mb-3" style={{ color: "#1976d2" }}>{t("Added Filters")}</h6>
              {filters.map((filter, idx) => {
                const meta = filterFields.find((f) => f.name === filter.field);
                return (
                  <div key={idx} className="card mb-2"
                    style={{ border: "none", borderRadius: "8px", boxShadow: "0 1px 4px rgba(0,0,0,0.03)" }}>
                    <div className="card-body d-flex justify-content-between align-items-center" style={{ padding: "12px 16px" }}>
                      <div className="flex-grow-1" style={{ fontSize: "14px" }}>
                        <span className="fw-semibold" style={{ color: "#374151" }}>{meta?.label || filter.field}</span>{" "}
                        {filter.operator === "between" && Array.isArray(filter.value) ? (
                          <>
                            <span style={{ background: "#e3e8ef", borderRadius: "4px", padding: "2px 8px", fontWeight: 500, color: "#1976d2" }}>between</span>{" "}
                            <span className="fw-semibold" style={{ color: "#374151" }}>{filter.value[0]}</span>{" "}
                            <span style={{ background: "#e3e8ef", borderRadius: "4px", padding: "2px 8px", fontWeight: 500, color: "#1976d2" }}>and</span>{" "}
                            <span className="fw-semibold" style={{ color: "#374151" }}>{filter.value[1]}</span>
                          </>
                        ) : (
                          <>
                            <span style={{ background: "#e3e8ef", borderRadius: "4px", padding: "2px 8px", fontWeight: 500, color: "#1976d2" }}>{filter.operator}</span>{" "}
                            <span className="fw-semibold" style={{ color: "#374151" }}>
                              {Array.isArray(filter.value) ? filter.value.map((v) => v.label || String(v)).join(", ") : String(filter.value)}
                            </span>
                          </>
                        )}
                      </div>
                      <div className="d-flex gap-1">
                        <button className="btn btn-outline-primary btn-sm p-1" onClick={() => handleEditFilter(idx)}>
                          <i className="material-symbols-outlined" style={{ fontSize: "16px" }}>edit</i>
                        </button>
                        <button className="btn btn-outline-danger btn-sm p-1" onClick={() => handleRemoveFilter(idx)}>
                          <i className="material-symbols-outlined" style={{ fontSize: "16px" }}>close</i>
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          {/* Save as Template */}
          {hasConditions() && (
            <div className="mt-4">
              <button type="button" className="btn btn-link text-primary p-0" onClick={() => setShowSaveFilterSection((p) => !p)}>
                {selectedFilterTemplate ? t("Update Template") : t("Save as Template")}
              </button>
              {showSaveFilterSection && (
                <div className="mt-3">
                  <label className="fw-semibold">{t("Filter Template Name")}</label>
                  <input type="text" className="form-control border border-secondary rounded mb-2"
                    placeholder={t("Enter filter template name")} value={filterTemplateName}
                    onChange={(e) => setFilterTemplateName(e.target.value)} />
                  <div className="form-check mb-3">
                    <input className="form-check-input border border-secondary" type="checkbox"
                      id="templateFilterDefault" checked={isDefaultTemplate}
                      onChange={(e) => setIsDefaultTemplate(e.target.checked)} />
                    <label className="form-check-label fw-semibold ms-2" htmlFor="templateFilterDefault">
                      {t("Save as Default Template")}
                    </label>
                  </div>
                  <div className="d-flex gap-2">
                    <button type="button" className="btn btn-outline-primary" onClick={handleSaveFilterTemplate}>
                      {selectedFilterTemplate ? t("Update Template") : t("Save Template")}
                    </button>
                    {selectedFilterTemplate && (
                      <button type="button" className="btn btn-outline-danger" onClick={deleteSelectedFilter}>
                        {t("Delete Template")}
                      </button>
                    )}
                  </div>
                </div>
              )}
            </div>
          )}

        </form>
      </div>

      {notification && <span className="ms-2 text-success small">{notification}</span>}

      <div className="offcanvas-footer bottom-0 start-0 end-0 bg-white p-3 border-top d-flex justify-content-between align-items-center">
        <button type="button"
          className={`btn ${hasConditions() ? "btn-primary" : "btn-outline-primary"} flex-grow-1`}
          onClick={hasConditions() ? searchHandler : undefined} disabled={!hasConditions()}>
          {t("Apply Filter")}
        </button>
        <button type="button" className="btn btn-outline-secondary ms-2"
          onClick={() => { resetHandler(); reloadList(); }}>
          {t("Reset")}
        </button>
      </div>
    </div>
  );
};

export default AutomationTemplateFilterPopup;
